/* ============================================================================
   hej-reveal.js — Apple-stijl reveal-laag voor de vijf categoriepagina's.
   Zie assets/hej-reveal.css voor de drie lagen en layout/theme.liquid voor
   het inline bootscript. Puur een animatielaag over de bestaande pagina;
   er wijzigt niets aan structuur, content of bestaande interacties.

   Kernpunten (spec gebruiker 2026-07-17 + eigen Apple-meting):
   - eenheden = bestaande content-elementen (koppen, kaarten, rijen), nooit
     de volle-breedte sectieband; heuristiek daalt af door doorgeefluiken
     en volle-breedte wrappers tot de rij met 2+ substantiële kinderen;
   - opening: eerste elementen gestaffeld (50ms per stap, max 220ms), de
     rest van het eerste scherm sluit aan zodra de layout stabiel is;
   - scroll: één centrale IntersectionObserver, elk element één keer,
     batch-stagger 60ms met een plafond van 400ms (mobiel 40/200);
   - beeld-dominante elementen krijgen de subtiele schaalvariant;
   - NA AFLOOP worden alle reveal-classes en inline delays weer verwijderd,
     zodat elementen exact hun oorspronkelijke CSS terugkrijgen (bestaande
     hover-transforms blijven onaangetast) en will-change wordt losgelaten;
   - mobiel (<=600px) doet mee met kleinere waarden; vangnetten: geen effect
     bij reduced-motion, in de theme-editor of zonder IntersectionObserver,
     en zonder JS wordt er nooit iets verborgen.
   ========================================================================= */
(function () {
  'use strict';

  var html = document.documentElement;
  function schoonBoot() { html.classList.remove('hej-reveal-boot'); }

  try {
    if (!('IntersectionObserver' in window)) { schoonBoot(); return; }
    if (window.Shopify && window.Shopify.designMode) { schoonBoot(); return; }
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { schoonBoot(); return; }
  } catch (e) { schoonBoot(); return; }

  var MOBIEL = window.matchMedia('(max-width: 600px)').matches;
  var OPEN_BASIS = 200;                  /* lege tel vóór er iets verschijnt (wens gebruiker: 0,2s) */
  var TITEL_PAUZE = MOBIEL ? 280 : 350;  /* de titel krijgt eerst duidelijk zijn eigen moment */
  /* rustige domino, tempo verder versneld op verzoek (2026-07-17) */
  var OPEN_STAP = MOBIEL ? 150 : 170;
  var OPEN_MAX = MOBIEL ? 750 : 850;
  var BATCH_STAP = MOBIEL ? 150 : 170;   /* zelfde ritme binnen een scroll-golf */
  var BATCH_MAX = MOBIEL ? 750 : 850;
  var SNEL_STAP = 40;                    /* ritme wanneer er hard gescrold wordt */
  var SNEL_MAX = 160;
  var DUUR_MAX = 760;                    /* langste transitieduur */
  var ENTREE_AANTAL = 8;                 /* eerste N elementen in documentvolgorde */
  var MAX_DIEPTE = 4;
  /* Zelf-animerende componenten (wisselaars/tickers die eigen inline
     opacity of klonen beheren) nooit opsplitsen: hun kinderen individueel
     wapenen vecht met hun eigen mechanisme (bug merkvergelijking
     2026-07-17). Ze faden als één geheel; uitbreidbaar via het
     data-attribuut op de houder. */
  var NIET_SPLITSEN = '[data-hej-reveal-heel]';
  /* Elementen die hun eigen reveal regelen (zoals de merkvergelijkingslijst,
     die een ingebouwde kaart-voor-kaart onthulling in de sectie zelf heeft
     sinds 2026-07-18) worden door deze laag volledig met rust gelaten. */
  var NIET_MEEDOEN = '[data-hej-reveal-skip], .hej-lk__mc-list';
  /* laag genoeg zodat ook kleine koppen en tekstlinks ("Kies jouw merk",
     "Bekijk gehele collectie") meedoen in de domino; alleen echt
     onzichtbare wrappers en ankers vallen af (bugfix 2026-07-17) */
  var MIN_HOOGTE = 12;

  var units = [];
  var entreeStart = 0;
  var laatsteEntreeDelay = 0; /* start van de laatste entree-steen, voor golf-aansluiting */

  /* ── Scrollsnelheid bijhouden: bij hard scrollen schakelen de golven naar
     een snelle stand zodat de bezoeker het effect nooit "inhaalt" ───────── */
  var scrollMeting = { t: 0, y: 0 };
  var scrollSnelheid = 0; /* px per ms */
  window.addEventListener('scroll', function () {
    var nu = performance.now();
    if (scrollMeting.t && nu - scrollMeting.t > 30) {
      scrollSnelheid = Math.abs(window.scrollY - scrollMeting.y) / (nu - scrollMeting.t);
      scrollMeting = { t: nu, y: window.scrollY };
    } else if (!scrollMeting.t) {
      scrollMeting = { t: nu, y: window.scrollY };
    }
  }, { passive: true });
  function isSnelScroll() {
    if (performance.now() - scrollMeting.t > 300) return false; /* meting verlopen */
    return scrollSnelheid > 1.6; /* ~1600px per seconde */
  }

  /* na een refresh midden op de pagina geen ceremonie bovenaan afdraaien */
  function isGescrold() { return window.scrollY > window.innerHeight * 0.4; }

  function zichtbareKinderen(el) {
    var uit = [];
    for (var i = 0; i < el.children.length; i++) {
      var k = el.children[i];
      if (/^(STYLE|SCRIPT|LINK|TEMPLATE|NOSCRIPT)$/.test(k.tagName)) continue;
      if (k.offsetHeight < MIN_HOOGTE) continue;
      uit.push(k);
    }
    return uit;
  }
  function isVolBreed(el) { return el.getBoundingClientRect().width > window.innerWidth * 0.95; }

  function verzamel() {
    var lijst = [];
    document.querySelectorAll('main [id^="shopify-section-template--"]').forEach(function (sec) {
      function daal(el, diepte) {
        var kids = zichtbareKinderen(el);
        if (!kids.length || diepte >= MAX_DIEPTE) { lijst.push(el); return; }
        if (kids.length === 1) { daal(kids[0], diepte + 1); return; } /* doorgeefluik */
        kids.forEach(function (k) {
          if (isVolBreed(k) && diepte + 1 < MAX_DIEPTE) { daal(k, diepte + 1); }
          else { lijst.push(k); }
        });
      }
      /* bij de sectie-wrapper zelf beginnen: zichtbareKinderen slaat style/
         script over; firstElementChild kon een <style> zijn waardoor de
         hele sectie ongewapend bleef (bug accessoires-hero 2026-07-18) */
      daal(sec, 0);
    });
    return splitsHomogeen(lijst);
  }

  /* Houder met eigen zichtbare opmaak (achtergrond, schaduw, rand)? Dan mag
     hij niet opgesplitst worden: anders blijft die opmaak als losse schil
     zichtbaar terwijl de inhoud nog verstopt is (bug met de witte
     navigatiecapsule, 2026-07-17). */
  function heeftEigenOpmaak(el) {
    var cs = getComputedStyle(el);
    if (cs.backgroundImage !== 'none') return true;
    var bg = cs.backgroundColor;
    if (bg !== 'rgba(0, 0, 0, 0)' && bg !== 'transparent') return true;
    if (cs.boxShadow && cs.boxShadow !== 'none') return true;
    if (parseFloat(cs.borderTopWidth) > 0 || parseFloat(cs.borderBottomWidth) > 0) return true;
    return false;
  }

  /* Eén niveau dieper voor groepen van gelijksoortige elementen: een rij of
     grid met allemaal hetzelfde soort kind (4 merkkaarten, 8 FAQ-items)
     wordt opgesplitst zodat elke kaart zijn eigen dominosteen is
     (wens gebruiker 2026-07-17). Gemengde inhoud blijft één geheel, en
     houders met eigen opmaak ook. */
  function splitsHomogeen(lijst) {
    var uit = [];
    lijst.forEach(function (el) {
      var kern = el;
      var kids = zichtbareKinderen(kern);
      while (kids.length === 1) { kern = kids[0]; kids = zichtbareKinderen(kern); }
      try {
        if (kern.matches(NIET_MEEDOEN) || el.matches(NIET_MEEDOEN)) return; /* regelt zijn eigen reveal */
      } catch (fout) {}
      var zelfAnimerend = false;
      try { zelfAnimerend = kern.matches(NIET_SPLITSEN) || el.matches(NIET_SPLITSEN); } catch (fout) {}
      if (zelfAnimerend) { uit.push(el); return; } /* expliciet als één geheel gemarkeerd */
      if (kids.length >= 2 && !heeftEigenOpmaak(kern) && (kern === el || !heeftEigenOpmaak(el))) {
        var soort = function (k) { return k.tagName + '.' + ((k.className || '').toString().split(/\s+/)[0] || ''); };
        var eerste = soort(kids[0]);
        var zelfde = kids.every(function (k) { return soort(k) === eerste; });
        /* gestapelde wisselaars (kaarten op dezelfde positie, sectie regelt
           zelf welke zichtbaar is) NIET splitsen: losse fades vechten met
           het wisselmechanisme en kunnen een kaart onzichtbaar achterlaten
           (bug merkvergelijking 2026-07-17) */
        var r0 = kids[0].getBoundingClientRect(), r1 = kids[1].getBoundingClientRect();
        var gestapeld = Math.abs(r0.left - r1.left) < 8 && Math.abs(r0.top - r1.top) < 8;
        if (zelfde && !gestapeld) { uit.push.apply(uit, kids); return; }
      }
      uit.push(el);
    });
    return uit;
  }

  /* Iedereen dezelfde fade + omhoog. De eerdere scale-variant voor beeld-
     elementen is bewust verwijderd: schaal-animaties geven op schermen met
     Windows-schaling een zichtbare scherpstel-pop na afloop (2026-07-17). */
  function wapen(el) {
    el.classList.add('hej-reveal');
  }

  /* onthullen + daarna ALLE sporen opruimen zodat het element weer zijn
     oorspronkelijke CSS heeft (hovers, transforms, will-change) */
  function toon(el, vertragingMs, snel) {
    el.style.transitionDelay = vertragingMs ? vertragingMs + 'ms' : '';
    if (snel) el.classList.add('hej-reveal--snel');
    el.classList.add('hej-reveal--in');
    var klaar = false;
    function opruimen() {
      if (klaar) return; klaar = true;
      el.style.transitionDelay = '';
      el.classList.remove('hej-reveal', 'hej-reveal--in', 'hej-reveal--snel');
    }
    el.addEventListener('transitionend', function h(e) {
      if (e.target !== el || e.propertyName !== 'opacity') return;
      el.removeEventListener('transitionend', h);
      opruimen();
    });
    setTimeout(opruimen, (vertragingMs || 0) + DUUR_MAX + 250); /* vangnet */
  }

  function init() {
    try {
      units = verzamel();
      if (!units.length) { schoonBoot(); return; }

      /* per element wapenen en in dezelfde tik de boot-laag opheffen: één
         style-berekening, dus geen flits en banden meteen statisch zichtbaar */
      units.forEach(wapen);
      schoonBoot();

      /* opening: eerst een lege tel (OPEN_BASIS), dan de titel solo, dan pas
         de overige elementen met zichtbare tussenstappen. Documentvolgorde,
         want posities zijn vóór het laden van de afbeeldingen onbetrouwbaar.
         MAAR: na een refresh midden op de pagina (scrollpositie hersteld)
         slaan we de hele ceremonie over; de bezoeker kijkt dan niet naar de
         top en moet niet wachten op een onzichtbare opening (2026-07-18). */
      entreeStart = performance.now();
      laatsteEntreeDelay = 0;
      if (!isGescrold()) {
        var entree = units.slice(0, ENTREE_AANTAL).filter(function (el) {
          return el.offsetHeight > 10; /* onzichtbare wrappers geen tijdslot geven */
        });
        var titelIdx = entree.findIndex(function (el) {
          return el.tagName === 'H1' || el.querySelector('h1');
        });
        if (titelIdx > 0) { entree.unshift(entree.splice(titelIdx, 1)[0]); }
        laatsteEntreeDelay = OPEN_BASIS;
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            entree.forEach(function (el, i) {
              var vertraging = i === 0
                ? OPEN_BASIS
                : OPEN_BASIS + TITEL_PAUZE + Math.min((i - 1) * OPEN_STAP, OPEN_MAX);
              if (vertraging > laatsteEntreeDelay) laatsteEntreeDelay = vertraging;
              toon(el, vertraging);
            });
          });
        });
      }

      /* tweede fase pas als de layout aantoonbaar stabiel is (pagina is
         "ingeklapt" zolang afbeeldingen laden; te vroeg meten laat verre
         secties hun onthulling ongezien verbruiken). Na een mid-page
         refresh pollen we sneller zodat de zichtbare sectie vlot komt. */
      var faseGestart = false;
      function startFase() { if (faseGestart) return; faseGestart = true; faseScroll(); }

      /* wie direct na het laden begint te scrollen wacht nooit op de
         stabilisatie: waarnemers gaan dan per direct aan (2026-07-18) */
      var startY = window.scrollY;
      window.addEventListener('scroll', function vroegeScroll() {
        if (Math.abs(window.scrollY - startY) > 40) {
          window.removeEventListener('scroll', vroegeScroll);
          startFase();
        }
      }, { passive: true });

      var interval = isGescrold() ? 100 : 200;
      var maxPogingen = isGescrold() ? 8 : 12;
      var vorige = -1, gelijk = 0, pogingen = 0;
      (function wachtOpLayout() {
        if (faseGestart) return;
        var h = document.body.scrollHeight;
        pogingen++;
        if (h === vorige && h > 0) { gelijk++; } else { gelijk = 0; }
        vorige = h;
        if (gelijk >= 2 || pogingen >= maxPogingen) { startFase(); return; }
        setTimeout(wachtOpLayout, interval);
      })();
    } catch (e) {
      schoonBoot();
      units.forEach(function (el) { el.classList.add('hej-reveal--in'); });
    }
  }

  function faseScroll() {
    /* alles buiten de entree onthult op ECHTE zichtbaarheid, gegroepeerd
       per visueel blok: zodra de bovenkant van een blok in beeld komt,
       vloeit het HELE blok als één golf binnen (wens gebruiker 2026-07-17).
       Blok = het kind van de sectie-root waar het element onder valt. */
    var wachtend = units.filter(function (el) {
      return el.classList.contains('hej-reveal') && !el.classList.contains('hej-reveal--in');
    });
    if (!wachtend.length) return;

    function blokVan(el) {
      var sec = el.closest('[id^="shopify-section-template--"]');
      if (!sec) return el;
      var node = el;
      while (node.parentElement && node.parentElement !== sec) {
        node = node.parentElement;
      }
      /* blok = het visuele blok onder de sectie-inhoud; als de sectie-inhoud
         maar één wrapper is, is het kind daarvan het echte bloknivo */
      var inhoud = node;
      var binnen = el;
      while (binnen.parentElement && binnen.parentElement !== inhoud) binnen = binnen.parentElement;
      return inhoud.getBoundingClientRect().height > window.innerHeight * 1.6 && binnen !== el ? binnen : inhoud;
    }

    var blokken = new Map(); /* blok-element -> [units in documentvolgorde] */
    wachtend.forEach(function (el) {
      var blok = blokVan(el);
      if (!blokken.has(blok)) blokken.set(blok, []);
      blokken.get(blok).push(el);
    });

    try {
      /* element-observer voor eenheden die bij de blok-start nog (ver)
         onder de schermrand liggen: die faden pas als ze zelf in beeld
         komen, anders speelt hun fade zich buiten beeld af en lijken ze
         "in één keer gespawnd" (feedback 2026-07-17) */
      var elIo = new IntersectionObserver(function (entries) {
        var zichtbaar = entries.filter(function (e) { return e.isIntersecting; });
        var snel = isSnelScroll();
        var stap = snel ? SNEL_STAP : BATCH_STAP;
        var max = snel ? SNEL_MAX : BATCH_MAX;
        zichtbaar.forEach(function (e, i) {
          if (e.target.classList.contains('hej-reveal') && !e.target.classList.contains('hej-reveal--in')) {
            toon(e.target, Math.min(i * stap, max), snel);
          }
          elIo.unobserve(e.target);
        });
      }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 });

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var lijst = blokken.get(entry.target) || [];
          /* eerste golf sluit aan op het staartje van de entree; na een
             mid-page refresh is er geen ceremonie en dus geen wachttijd */
          var rest = isGescrold() ? 0 : Math.max(0, (entreeStart + laatsteEntreeDelay + OPEN_STAP) - performance.now());
          var snel = isSnelScroll();
          var stap = snel ? SNEL_STAP : BATCH_STAP;
          var max = snel ? SNEL_MAX : BATCH_MAX;
          var teller = 0;
          var grens = window.innerHeight * 1.12; /* in beeld of er net onder */
          lijst.forEach(function (el) {
            if (!el.classList.contains('hej-reveal') || el.classList.contains('hej-reveal--in')) return;
            if (el.getBoundingClientRect().top < grens) {
              toon(el, rest + Math.min(teller * stap, max), snel);
              teller++;
            } else {
              elIo.observe(el); /* eigen fade zodra dit element zelf in beeld komt */
            }
          });
          io.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
      blokken.forEach(function (lijst, blok) { io.observe(blok); });
    } catch (e) {
      wachtend.forEach(function (el) { el.classList.add('hej-reveal--in'); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
